<template>
  <div class="productWrap">
    <div class="translateX">
      <div class="degWrap">
        <div class="ptBox">
          <div class="flexItem" v-for="(item, index) in headProduct" :key="index">
            <div
              class="bnImg"
              v-for="(it, i) in item"
              :key="`1-${i}`"
              :style="{ background: `url(${it.src}) center center no-repeat`, backgroundSize: 'cover' }"
              @click="openProducts(it.url)"
            ></div>
            <div
              class="bnImg"
              v-for="(it, i) in item"
              :key="`2-${i}`"
              :style="{ background: `url(${it.src}) center center no-repeat`, backgroundSize: 'cover' }"
              @click="openProducts(it.url)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollProduct } from '@/utils/const'
export default {
  name: 'MbScrollProduct',
  data() {
    return {
      visible: false,
      headProduct: scrollProduct
    }
  },
  props: [],
  computed: {},
  components: {},
  watch: {},
  methods: {
    openProducts(url) {
      this.$router.push(url)
    }
  },
  mounted() {},
  destroyed() {}
}
</script>

<style lang="less" scoped>
@-webkit-keyframes home-scroll-grid-infinite {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}
@keyframes home-scroll-grid-infinite {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}
@media screen and (max-width: 960px) {
  .productWrap {
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 350px;
    background: linear-gradient(180deg, #ffb300 0%, #f48900 100%);
    z-index: 0;
    .translateX {
      // transform: translate(-72vw, -40vw);
    }

    .degWrap {
      // margin-left: -80%;

      transform: rotate(30deg);
      transform-origin: 80% 10%;
    }
    .ptBox {
      display: flex;
      justify-content: space-between;

      animation-play-state: running;
      -webkit-animation-play-state: running;
      -webkit-animation: home-scroll-grid-infinite 30s linear 0s infinite;
      animation: home-scroll-grid-infinite 30s linear 0s infinite;

      &:hover {
        animation-play-state: paused;
        -webkit-animation-play-state: paused;
      }
      .flexItem {
        width: 25%;
        padding: 4px;
        .bnImg {
          width: 100%;
          height: 110px;
          margin: 8px 0;
          border-radius: 4px;
          box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
          transition: transform 0.3s;
          background-size: cover;
          cursor: pointer;
          &:hover {
            transform: scale(1.08);
          }
        }
      }
    }
  }
}
</style>
